import React, { createContext, useContext, useState } from 'react';

const PaymentContext = createContext();

export const usePayment = () => {
    const context = useContext(PaymentContext);
    if (!context) {
        throw new Error('usePayment must be used within a PaymentProvider');
    }
    return context;
};

export const PaymentProvider = ({ children }) => {
    const [paymentResponse, setPaymentResponse] = useState(null);
    const [currentPayment, setCurrentPayment] = useState(null);

    return (
        <PaymentContext.Provider
            value={{
                paymentResponse,
                setPaymentResponse,
                currentPayment,
                setCurrentPayment
            }}
        >
            {children}
        </PaymentContext.Provider>
    );
};

